export enum REPAIRER_DOMAIN {
  LIST = 'list',
  BY_SELLER_ID = 'bySellerId',
  BY_TYPE = 'byType',
}

export const REPAIRER_DOMAIN_KEY = 'repairer';
